import { render, staticRenderFns } from "./FormAsignacionVehiculos.vue?vue&type=template&id=16115506&scoped=true&"
import script from "./FormAsignacionVehiculos.vue?vue&type=script&lang=ts&"
export * from "./FormAsignacionVehiculos.vue?vue&type=script&lang=ts&"
import style0 from "./FormAsignacionVehiculos.vue?vue&type=style&index=0&id=16115506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16115506",
  null
  
)

export default component.exports